import { useEffect, useState } from 'react'

import { get } from '../../../utils/api'
import { PatchStrategy } from './types'

export type PatchStrategies = PatchStrategy[]

export const usePatchStrategiesData = () => {
  const [patchStrategies, setPatchStrategies] = useState<PatchStrategies>([])
  const [patchSrategyDft, setPatchSrategyDft] = useState<PatchStrategy>()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    get<PatchStrategies>(`/patch_strategies`)
      .then((data) => {
        setPatchStrategies(data)
        setPatchSrategyDft(data.filter((strategy) => strategy.isDefault)[0])
      })
      .finally(() => setIsLoading(false))
  }, [])

  return {
    patchStrategies,
    patchSrategyDft,
    patchStrategiesIsLoading: isLoading,
  }
}
